import { AfterViewInit, Component, ElementRef, Input, ViewChild, inject } from '@angular/core';

import { PoliticianService } from '../../services/politician.service';
import { UserService } from '../../services/user.service';
import { ToastComponent } from '../toast/toast.component';
import { ee } from '../constants';
import { fromEvent } from 'rxjs';
import { debounceTime, finalize, map } from 'rxjs/operators';

@Component({
  selector: 'app-search-filter',
  templateUrl: './search-filter.component.html',
  standalone: false
})
export class SearchFilterComponent implements AfterViewInit {
  private politicianService = inject(PoliticianService);
  private userService = inject(UserService);
  toast = inject(ToastComponent);


  @Input() item: any;
  @ViewChild('searchInput') searchInput: ElementRef;

  isLoading = false;
  hideMenu = true;
  itemName = '';
  itemsFound = [];


  ngAfterViewInit(): void {
    this.searchEvent();
  }

  searchEvent(): void {
    this.itemsFound = [];
    fromEvent(this.searchInput.nativeElement, 'input')
      .pipe(
        map((event: any) => event.target.value),
        debounceTime(400),
      )
      .subscribe({
        next: (text: string) => {
          this.isLoading = true;
          this.itemsFound = [];
          if (text) {
            this.findItem(text);
          } else {
            this.isLoading = false;
            this.itemsFound = [];
            ee.emit('setPoliticianFilter', '');
          }
        }
      });
  }

  findItem(lastName: string): void {
    const service = {
      politician: this.politicianService,
      user: this.userService,
    };
    service.politician.search({ lastName, perPage: 10 })
      .pipe(finalize(() => {
        this.hideMenu = false;
        this.isLoading = false;
      }))
      .subscribe({
        next: res => this.itemsFound = res.results || [],
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

  selectItem(item: any): void {
    this.item = item._id;
    ee.emit('setPoliticianFilter', this.item);
    this.itemName = `${item.firstName} ${item.lastName}`;
    this.hideMenu = true;
  }

}
